import { render, staticRenderFns } from "./kartuangsuran.vue?vue&type=template&id=0d5395db&scoped=true&"
import script from "./kartuangsuran.vue?vue&type=script&lang=js&"
export * from "./kartuangsuran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5395db",
  null
  
)

export default component.exports